<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
let data = {
    "name": "flare",
    "children": [{
            "name": "analytics",
            "children": [{
                    "name": "cluster",
                    "children": [
                        { "name": "AgglomerativeCluster", "value": 3938 },
                        { "name": "MergeEdge", "value": 743 }
                    ]
                },
                {
                    "name": "graph",
                    "children": [
                        { "name": "BetweennessCentrality", "value": 3534 },
                        { "name": "LinkDistance", "value": 5731 },
                    ]
                },
                {
                    "name": "optimization",
                    "children": [
                        { "name": "AspectRatioBanker", "value": 7074 }
                    ]
                }
            ]
        },
        {
            "name": "util",
            "children": [
                { "name": "Arrays", "value": 8258 },
                { "name": "Colors", "value": 10001 },
                { "name": "Dates", "value": 8217 },
                {
                    "name": "heap",
                    "children": [
                        { "name": "FibonacciHeap", "value": 9354 },
                        { "name": "HeapNode", "value": 1233 }
                    ]
                },
                { "name": "IEvaluable", "value": 335 },
                { "name": "IPredicate", "value": 383 },
                { "name": "IValueProxy", "value": 874 },
                {
                    "name": "math",
                    "children": [
                        { "name": "DenseMatrix", "value": 3165 },
                    ]
                },
                { "name": "Maths", "value": 17705 },
                { "name": "Orientation", "value": 1486 },
                {
                    "name": "palette",
                    "children": [
                        { "name": "ColorPalette", "value": 6367 },
                        { "name": "Palette", "value": 1229 },
                    ]
                },
                { "name": "Property", "value": 5559 },
                { "name": "Shapes", "value": 19118 },
            ]
        },
        {
            "name": "vis",
            "children": [{
                    "name": "axis",
                    "children": [
                        { "name": "Axes", "value": 1302 },
                        { "name": "Axis", "value": 24593 },
                        { "name": "AxisGridLine", "value": 652 },
                        { "name": "AxisLabel", "value": 636 },
                        { "name": "CartesianAxes", "value": 6703 }
                    ]
                },
                {
                    "name": "controls",
                    "children": [
                        { "name": "AnchorControl", "value": 2138 },
                        { "name": "ControlList", "value": 4665 },
                    ]
                },
                {
                    "name": "data",
                    "children": [
                        { "name": "Data", "value": 20544 },
                        { "name": "DataList", "value": 19788 },
                        { "name": "DataSprite", "value": 10349 },
                        { "name": "EdgeSprite", "value": 3301 },
                        { "name": "NodeSprite", "value": 19382 },
                        {
                            "name": "render",
                            "children": [
                                { "name": "ArrowType", "value": 698 },
                            ]
                        },
                        { "name": "ScaleBinding", "value": 11275 },
                        { "name": "Tree", "value": 7147 },
                        { "name": "TreeBuilder", "value": 9930 }
                    ]
                },
                {
                    "name": "events",
                    "children": [
                        { "name": "DataEvent", "value": 2313 },
                        { "name": "SelectionEvent", "value": 1880 },
                        { "name": "TooltipEvent", "value": 1701 },
                        { "name": "VisualizationEvent", "value": 1117 }
                    ]
                },
                {
                    "name": "legend",
                    "children": [
                        { "name": "Legend", "value": 20859 },
                        { "name": "LegendItem", "value": 4614 },
                        { "name": "LegendRange", "value": 10530 }
                    ]
                },
                {
                    "name": "operator",
                    "children": [{
                            "name": "distortion",
                            "children": [
                                { "name": "BifocalDistortion", "value": 4461 },
                                { "name": "Distortion", "value": 6314 },
                                { "name": "FisheyeDistortion", "value": 3444 }
                            ]
                        },
                        {
                            "name": "encoder",
                            "children": [
                                { "name": "ColorEncoder", "value": 3179 },
                                { "name": "Encoder", "value": 4060 },
                            ]
                        },
                        {
                            "name": "filter",
                            "children": [
                                { "name": "FisheyeTreeFilter", "value": 5219 },
                            ]
                        },
                        { "name": "IOperator", "value": 1286 },
                        {
                            "name": "label",
                            "children": [
                                { "name": "Labeler", "value": 9956 },
                                { "name": "RadialLabeler", "value": 3899 },
                                { "name": "StackedAreaLabeler", "value": 3202 }
                            ]
                        },
                        {
                            "name": "layout",
                            "children": [
                                { "name": "AxisLayout", "value": 6725 },
                                { "name": "BundledEdgeRouter", "value": 3727 },
                            ]
                        },
                        { "name": "Operator", "value": 2490 },
                        { "name": "OperatorList", "value": 5248 },
                    ]
                },
                { "name": "Visualization", "value": 16540 }
            ]
        }
    ]
}

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData || {})
        },
        setOptions(data1) {
            let _this = this;
            this.chart.setOption({
                tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove',
                    backgroundColor:'rgba(255,255,255,1)'
                },
                series: [{
                    type: 'tree',
                    data: [data],
                    top: '40%',
                    lef: '35%',
                    right: '8%',
                    bottom: '18%',
                    layout: 'radial',
                    label: {
                        color: _this.isbig ? '#AABEFF' : ''
                    },
                    symbol: 'emptyCircle',
                    symbolSize: 7,
                    initialTreeDepth: 3,
                    animationDurationUpdate: 750,
                    emphasis: {
                        focus: 'descendant'
                    }
                }]
            })
        }
    }
}

</script>
